import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import Faq, { FAQS } from "@/pages/Faq";
import { faqPageJsonLd, breadcrumbJsonLd } from "@/lib/seoSchema";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/faq")({
  head: () => ({
    meta: [
      { title: "Football Predictions FAQ: How Statlign Works" },
      { name: "keywords", content: seoFor({ topics: ["faq"] }).meta },
      { name: "description", content: "Straight answers on Statlign's AI football predictions, accuracy, odds and responsible betting. No jargon, no hedging." },
      { property: "og:title", content: "Football Predictions FAQ: How Statlign Works" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Straight answers on Statlign's AI football predictions, accuracy, odds and responsible betting. No jargon, no hedging." },
      { name: "twitter:title", content: "Football Predictions FAQ: How Statlign Works" },
      { name: "twitter:description", content: "Straight answers on Statlign's AI football predictions, accuracy, odds and responsible betting. No jargon, no hedging." },
    ],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(faqPageJsonLd(FAQS)) },
      { type: "application/ld+json", children: JSON.stringify(breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }])) },
    ],
  }),
  component: () => (
    <MainLayout>
      <Faq />
    </MainLayout>
  ),
});
